export const STORE_THEME_KEY = 'theme';

export enum EThemeMode {
  LIGHT = 'light',
  DARK = 'dark',
  SYSTEM = 'system',
}

export const CDefaultTheme: EThemeMode = EThemeMode.SYSTEM;

export type TResolvedTheme = EThemeMode.LIGHT | EThemeMode.DARK;
